import { z } from 'zod';

import {
  JobHistoryLevel,
  ProbationReviewFlag,
  ProbationReviewOutcome,
  ProbationReviewReviewStatus,
  ProbationStatus,
} from '@/common/graphql';

export const ProbationReview = z.object({
  employeeId: z.string().default(''),
  employeeName: z.string().default(''),
  hiredDate: z.string().default(''),
  companyName: z.string().default(''),
  countryName: z.string().default(''),
  officeLocation: z.string().default(''),
  businessUnit: z.string().default(''),
  level: z.nativeEnum(JobHistoryLevel).default(JobHistoryLevel.L0),
  primaryManager: z.string().default(''),
  primaryManagerId: z.string().default(''),
  probationStatus: z.nativeEnum(ProbationStatus).default(ProbationStatus.InProgress),
  outcome: z.nativeEnum(ProbationReviewOutcome).nullable().default(null),
  flags: z.array(z.nativeEnum(ProbationReviewFlag)).default([]),
  // "Review 2 of 3"; null for an employee who has left.
  currentReview: z.object({ index: z.number(), total: z.number() }).nullable().default(null),
  nextDueDate: z.string().nullable().default(null),
  daysOverdue: z.number().nullable().default(null),
  probationEndDate: z.string().nullable().default(null),
  // The review chosen for the selected month; null when no review applies.
  displayedReview: z
    .object({
      dueDate: z.string(),
      reviewStatus: z.nativeEnum(ProbationReviewReviewStatus),
      reviewerId: z.string().nullable().default(null),
      reviewerName: z.string().default(''),
    })
    .nullable()
    .default(null),
  reviewerAbsent: z.boolean().default(false),
  // Whether the audit log has an entry of this employee; the History control is shown only then.
  hasAuditLog: z.boolean().default(false),
  // Every review in order; Record Outcome lists the Draft ones it closes and Extend Probation the due dates.
  reviews: z
    .array(z.object({ deadline: z.string(), reviewStatus: z.nativeEnum(ProbationReviewReviewStatus) }))
    .default([]),
});

export type ProbationReviewType = z.infer<typeof ProbationReview>;
